import React, { useState } from "react";
import { Form, Card } from "react-bootstrap";

const PaymentOptions = () => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const paymentOptions = [
    { label: "Credit Card", value: "creditCard" },
    { label: "Debit Card", value: "debitCard" },
    { label: "PayPal", value: "paypal" },
  ];

  return (
    <div>
      <Form>
        {/* <form
        action="http://localhost:3001/confirmationpage"
        class="paymentWidgets"
        data-brands="VISA MASTER AMEX"
      ></form> */}
        {paymentOptions.map((option) => (
          <Card
            key={option.value}
            className={`mb-3 ${
              selectedOption === option.value ? "border-primary" : ""
            }`}
            onClick={() =>
              handleOptionChange({ target: { value: option.value } })
            }
          >
            <Card.Body>
              <Form.Check
                type="radio"
                label={option.label}
                value={option.value}
                checked={selectedOption === option.value}
                onChange={handleOptionChange}
              />
            </Card.Body>
          </Card>
        ))}
      </Form>
    </div>
  );
};

export default PaymentOptions;
